export const LOGIN = (state, user) => {
  state.auth.isLoggedIn = true
  state.auth.user = user
}

export const LOGINEX = (state, token) => {
  state.auth.externalApiKey = token
}

export const LOGOUT = (state) => {
  state.auth.isLoggedIn = false
  state.auth.user = {}
}

export const changeOutlet = (state, outletID) => {
  state.auth.user.outlet = +outletID
}

export const changeIsAllOutlet = (state, status) => {
  state.auth.isAllOutlet = status
}
/**
 * Clear each property, one by one, so reactivity still works.
 *
 * (ie. clear out state.auth.isLoggedIn so Navbar component automatically reacts to logged out state,
 * and the Navbar menu adjusts accordingly)
 *
 * TODO: use a common import of default state to reset these values with.
 */
export const CLEAR_ALL_DATA = (state) => {
  // Auth
  state.auth.isLoggedIn = false
  state.auth.accessToken = null
  state.auth.refreshToken = null

  // User
  state.user.name = ''
}



// WEBPACK FOOTER //
// ./src/store/mutations.js